import { createContext, useContext, useCallback, useState, useMemo } from 'react';
import styled from 'styled-components';
import uniqueId from 'lodash/uniqueId';
import last from 'lodash/last';
import {Backdrop, CircularProgress} from "@mui/material";

const StyledBackdrop = styled(Backdrop)`
  z-index: ${({ theme }) => theme.zIndex.modal + 1};
  color: #fff;
`;

const OverlayLoader = ({ color = 'inherit', ...rest }) => (
  <StyledBackdrop {...rest}>
    <CircularProgress color={color} />
  </StyledBackdrop>
);

const GlobalLoaderManagerContext = createContext(null);

// wrapper for the provider
export const GlobalLoaderManagerProvider = ({ children }) => {
  const [loaders, setLoaders] = useState([]);

  const showLoader = useCallback((props = {}) => {
    const id = uniqueId('globalLoader_');
    setLoaders(current => ([
      ...current,
      { id, props },
    ]));
    return id;
  }, []);

  const hideLoader = useCallback((id) => {
    setLoaders(current => {
      const newLoaders = current.filter((e) => e.id !== id);
      return newLoaders.length === current.length ? current : newLoaders;
    });
  }, []);

  const value = useMemo(() => ({
    showLoader,
    hideLoader,
  }), [showLoader, hideLoader]);

  const activeLoader = last(loaders);
  const loaderProps = activeLoader
    ? { ...activeLoader.props, open: true }
    : { open: false };

  return (
    <GlobalLoaderManagerContext.Provider value={value}>
      {children}
      <OverlayLoader {...loaderProps} />
    </GlobalLoaderManagerContext.Provider>
  );
};

// custom hook
export const useGlobalLoaderManager = () => useContext(GlobalLoaderManagerContext);
